import InputField from "components/fields/InputField";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";
import { API_URL } from "utils/config";
import axios from "axios";
import toast from "react-hot-toast";
import { resetPassword } from "../../redux/action/index";
import { useEffect, useState } from "react";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [captcha, setCaptcha] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const onPageToken = searchParams.get("token");
  console.log("onPageToken", onPageToken);

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;

    if (!passwordRegex.test(password)) {
      setPasswordError(
        "Password must be at least 12 characters long, include one special character, one number, one lowercase, and one uppercase letter."
      );
      return false;
    }

    setPasswordError("");
    return true;
  };
  // const validatePassword = (password) => {
  //   const passwordRegex = /^.{12,}$/;

  //   if (!passwordRegex.test(password)) {
  //     setPasswordError("Password must be at least 12 characters long.");
  //     return false;
  //   }

  //   setPasswordError("");
  //   return true;
  // };

  const validateConfirmPassword = () => {
    if (confirmPassword !== password) {
      setConfirmPasswordError("Passwords do not match.");
      return false;
    }
    setConfirmPasswordError("");
    return true;
  };

  //   captcha function
  const handleCaptchaChange = async (value) => {
    try {
      var body = {
        captcha: true,
        g_recaptcha_response: value,
      };
      var response = await axios.post(API_URL + "/auth/verify_captcha", body);
      console.log("recaptcha response", response);
      if (response?.data?.status === 200) {
        // setLoading(false);
        setCaptcha(true);
        setCaptchaVerified(true);
        console.log("captcha is verified");
      } else {
        toast.error(response?.data?.detail[0]?.msg);
        console.log("captcha is not verified");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  //   ----------  //

  const handleResetPassword = () => {
    // Run all validations and collect results

    const isPasswordValid = validatePassword(password);
    const isConfirmPasswordValid = validateConfirmPassword(confirmPassword);

    // If all validations pass, proceed with registration
    if (isPasswordValid && isConfirmPasswordValid) {
      try {
        dispatch(
          resetPassword({
            password: password,
            confirm_password: confirmPassword,
            onPageToken: onPageToken,
          })
        ).then((response) => {
          console.log("reset response", response);
          localStorage.clear();
          navigate("/auth/sign-in");
        });
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      toast.error("Please verify password.");
      console.log("Validation errors");
    }
  };

  return (
    <div className="mb-16 mt-28 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[1vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Reset Password
        </h4>
        <p className="mb-6 ml-1 text-base text-gray-600">
          Please fill in this form to create an account!
        </p>

        {/* Password */}
        <div className="mb-1 w-full">
          <InputField
            variant="auth"
            extra="mb-1"
            label="Password*"
            placeholder="Min. 12 characters"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            boxType="password"
          />
          {passwordError && (
            <p className="ml-1.5 text-sm text-red-500">{passwordError}</p>
          )}
        </div>

        {/* Confirm Password */}
        <div className="mb-1 w-full">
          <InputField
            variant="auth"
            extra="mb-1"
            label="Confirm Password*"
            placeholder="Min. 12 characters"
            id="confirm-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            type="password"
            boxType="password"
          />
          {confirmPasswordError && (
            <p className="ml-1.5 text-sm text-red-500">
              {confirmPasswordError}
            </p>
          )}
        </div>
        <div className="mb-1 w-full">
          {" "}
          <Turnstile
            sitekey="0x4AAAAAAAkH86FYslmjxCH3"
            // test key
            // sitekey="1x00000000000000000000AA"
            className="mt-2"
            onVerify={(token) => {
              handleCaptchaChange(token);
              // setCaptchaVerified(true);
              // setCaptcha(true);
            }}
          />
        </div>
        <button
          disabled={!captchaVerified || !captcha}
          onClick={() => handleResetPassword()}
          className="linear   mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          Submit
        </button>
      </div>
    </div>
  );
}
